import { render, staticRenderFns } from "./StorefrontOrdersImportSidebar.vue?vue&type=template&id=321e7160"
import script from "./StorefrontOrdersImportSidebar.vue?vue&type=script&lang=js"
export * from "./StorefrontOrdersImportSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports